import React from 'react';
import { getUserName } from './Handle.utils';
var defaultProps = {
  username: '',
  usernameRef: '',
  link: ''
};
export default function Handle(_ref) {
  var username = _ref.username,
    usernameRef = _ref.usernameRef,
    link = _ref.link;
  var finalUsername = getUserName(username, link);
  return /*#__PURE__*/React.createElement("span", {
    className: "social-platform-username"
  }, usernameRef, finalUsername);
}
Handle.defaultProps = defaultProps;